import type { FinancialViewRow } from "../types";
import { collectRowIds } from "./collectExpandableRowIds";

// Ids that should be expanded on first render: L1 sections and L2 categories only,
// unless a row opts out via defaultCollapsed. L3 groups (and deeper) start collapsed
// but still show their rollup totals; the toolbar Expand-all still walks every level
// via collectExpandableRowIds.
export const collectInitialExpandedRowIds = (rows: FinancialViewRow[]): string[] =>
	collectRowIds(rows, (row) => row.level <= 2 && !row.defaultCollapsed);
